import { MessagePopup } from '@renderforest/rf-components'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { ERROR_POPUP_DATA } from './consts'

const ErrorPopup = () => {
  const {
    alertPopupsData: {
      errorPopup: { type }
    },
    resetAlertPopupsData
  } = useAlertPopupsContext()

  if (!type) {
    return null
  }

  const { description } =
    ERROR_POPUP_DATA[type as keyof typeof ERROR_POPUP_DATA] ||
    ERROR_POPUP_DATA.default

  return (
    <MessagePopup
      isOpen
      type="error"
      title={translate(T.SOMETHING_WENT_WRONG_LABEL)}
      message={description}
      primaryAction={{
        label: translate(T.GOT_IT_LABEL),
        onClick: resetAlertPopupsData
      }}
      onClose={resetAlertPopupsData}
    />
  )
}

export default ErrorPopup
